import {ReactElement} from "react";
import style from './Modal.module.css'
import close from "../../image/ic_close.png"
export const Modal =({children, isOpen}:{children:ReactElement, isOpen:boolean})=>{
    if(!isOpen)return null
    
    return(
        <div className={style.modal_back}>
            {children}
        </div>
    )
}

Modal.Content = function ModalContent({children,isClosable=false, onClose}:{children:ReactElement,isClosable?:boolean,onClose?:()=>void}){
    return(
        <div className={style.modal_container}>
            {isClosable &&
            <div className={style.modal_close_button} onClick={onClose}>
                <img src={close}/>
            </div>}
            <div style={{margin:"10px"}}>
                <div className={style.modal_content}>
                    {children}
                </div>
            </div>
        </div>
    )
}